<template>
  <div class="table" v-loading="tableLoading">
    <el-table :data="data" width="100%">
      <el-table-column
        label="#"
        prop="id"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="Employee Name"
        width="200"
        :formatter="tableFormatter"
      >
      </el-table-column>
      <el-table-column
        prop="clock_date"
        label="date"
        width="200"
        :formatter="tableFormatter"
      >
      </el-table-column>
      <el-table-column
        prop="clock_type"
        label="Clock Type"
        width="200"
        :formatter="tableFormatter"
      >
      </el-table-column>
      <el-table-column
        prop="clock_time"
        label="Time"
        width="200"
        :formatter="tableFormatter"
      >
      </el-table-column>
      <el-table-column
        prop="clock_address"
        label="LOCATION"
        width="250"
        :formatter="tableFormatter"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="status"
        label="STATUS"
        width="140"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.status === 'approved'" class="status approve">
            Approved
          </div>
          <div v-if="scope.row.status === 'rejected'" class="status reject">
            Rejected
          </div>
          <div v-if="scope.row.status === 'pending'" class="status pending">
            Pending
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="action"
        label="Actions"
        width="150"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <div class="flex" v-if="scope">
            <button class="success mr-10 line" @click="accept">Accept</button>
            <button class="danger line" @click="reject">Reject</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="pagination-container">
      <el-pagination
        mini
        @size-change="handleSizeChangeForSalary"
        @current-change="handleCurrentChangeForSalary"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="perPageForSalary"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSalarySchedule"
      ></el-pagination>
    </div> -->
  </div>
</template>

<script>
import { tableFormatter } from "@/helpers/functions";

export default {
  props: ["data"],
  data() {
    return {
      tableLoading: false,
    };
  },
  methods: {
    tableFormatter,
    accept() {
      this.$promptModal(
        "Approve Mobile Clock",
        "Are you sure you want to approve the selected clock log?",
        "Yes, Approve",
        () => {}
      );
    },
    reject() {
      this.$promptModal(
        "Reject  Mobile Clock",
        "Are you sure you want to reject the selected clock log?",
        "Yes, reject",
        () => {}
      );
    },
  },
};
</script>

<style lang="css">
.drop-down-link {
  text-decoration: none;
  color: #606266;
}
.grey {
  background-color: #abb3bf;
  color: #091540;
}
</style>
